import FormFeedback from 'components/FormFeedback';
import FormProps from 'components/FormProps';
import RegistrationModel from 'models/authentication/registrationModel';
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

export type Props = FormProps<RegistrationModel>;

export const Create = ({
  value, disabled, error, onChange,
}: Props) => {
  const handleControlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;
    switch (event.target.name) {
      case 'email':
        onChange({ ...value, email: event.target.value }); break;
      case 'password':
        onChange({ ...value, password: event.target.value }); break;
      default: break;
    }
  };

  return (
    <>
      <Form.Group className="form-group">
        <InputGroup>
          <InputGroup.Text>Email</InputGroup.Text>
          <Form.Control
            name="email"
            disabled={disabled}
            value={value.email}
            onChange={handleControlChange}
            isInvalid={error?.email !== undefined}
          />
          <FormFeedback type="invalid" values={error?.email} />
        </InputGroup>
      </Form.Group>
      <Form.Group className="form-group">
        <InputGroup>
          <InputGroup.Text>Password</InputGroup.Text>
          <Form.Control
            name="password"
            type="password"
            disabled={disabled}
            value={value.password}
            onChange={handleControlChange}
            isInvalid={error?.password !== undefined}
          />
          <FormFeedback type="invalid" values={error?.password} />
        </InputGroup>
      </Form.Group>
    </>
  );
};

export default Create;
